export default {"src":"/_next/static/media/sparkle.8db0ed46.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};